export default {
  RECOMMEDED: "recommended",
  CURATED: "curated",
  QUERY: "query",
  CONTINUE_WATCHING: "continue_watching",
  EPG: "epg",
};
